export const permissionOptions = {
  full: 'Broad Content License',
  full_limited_time:'Limited Time Broad Content License',
  limited: 'Custom Content License',
  none: 'No Content License',
};
